import { InferType, object, string } from 'yup'
import { checkLuhn } from '@/lib/utils'

export interface IHIFormType extends InferType<typeof IHIFormValidator> {}

export const IHIFormValidator = object({
  ihi: string()
    .default('')
    .required('Please enter your IHI Number.')
    .test({
      name: 'is-valid-ihi',
      skipAbsent: false,
      test(value, ctx) {
        const err = checkLuhn(value, 'IHI')
        if (err !== null) {
          return ctx.createError({ message: err })
        }

        return true
      },
    }),
})
